const shippingCosts = {
    title: 'Verzendkosten',
    subtitle: 'Ontdek onze verzendopties en leveringstijden voor jouw locatie',
    selectCountry: 'Selecteer je land',
    availableOptions: 'Beschikbare verzendopties',
    options: 'opties',
    noOptions: 'Geen verzendopties beschikbaar voor dit land',
    contactUs: 'Neem contact met ons op voor verzendopties',
    default: 'Standaard',
    free: 'Gratis',
    minOrderAmount: 'Minimum bestelbedrag',
    aboveMinAmount: 'Boven minimumbedrag',
    importantInfo: 'Belangrijke Informatie',
    info1: 'Verzendkosten worden berekend op basis van het geselecteerde land',
    info2: 'Gratis verzending is beschikbaar voor bestellingen boven het minimumbedrag',
    info3: 'Leveringstijden kunnen variëren op basis van jouw locatie',
    info4: 'Neem contact met ons op voor speciale verzendafspraken',
    loading: 'Laden...',
    errorLoading: 'Fout bij laden verzendkosten',
    noDescription: 'Geen beschrijving beschikbaar'
};

export default shippingCosts;

